import { Outlet } from "react-router-dom";
import Navbar from "./Navbar";
import CategoriesNavbar from "./CategoriesNavbar";
// new: import Footer
import Footer from "./Footer";

const PublicLayout = () => {
  return (
    <>
      <Navbar />
      <CategoriesNavbar />
      <Outlet />
      <Footer />
    </>
  );
};

export default PublicLayout;
